// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ResourcesIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <g clipPath="url(#resources_svga)">
      <path
        fill="#B4B4B4"
        d="M20.4 9.72h-2.75V6.97a.6.6 0 0 0-.6-.6h-2.77V3.6a.6.6 0 0 0-.6-.6H3.6a.6.6 0 0 0-.6.6v10.08a.6.6 0 0 0 .6.6h2.76v2.75a.6.6 0 0 0 .6.6h2.76v2.77a.6.6 0 0 0 .6.6H20.4a.6.6 0 0 0 .6-.6V10.32a.6.6 0 0 0-.6-.6M6.36 6.97v6.11H4.21V4.2h8.87v2.15H6.97a.6.6 0 0 0-.6.62m3.36 3.35v6.12H7.57V7.56h8.87V9.7h-6.12a.6.6 0 0 0-.6.6M19.8 19.8h-8.88v-8.88h8.88z"
      />
    </g>
    <defs>
      <clipPath id="resources_svga">
        <path fill="#fff" d="M3 3h18v18H3z" />
      </clipPath>
    </defs>
  </svg>,
  "Resources",
);
export default ResourcesIcon;
